import { render } from "./VoiceAdmin.vue?vue&type=template&id=491a5419&scoped=true"
import script from "./VoiceAdmin.vue?vue&type=script&lang=js"
export * from "./VoiceAdmin.vue?vue&type=script&lang=js"

import "./VoiceAdmin.vue?vue&type=style&index=0&id=491a5419&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.4.19_vue@3.4.19_webpack@5.108.4_postcss@8.5.18_/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-491a5419"]])

export default __exports__